import React, {useState} from 'react';
import {Divider, Row, Col} from 'antd';
import {FormPedidoDescricoes} from './FormPedidoDescricoes';

const PedidoDescricoes = (props) => {
    const [visible, setVisible] = useState(false);

    const {campo, label} = props;

    return <><Divider orientation="left">{label}</Divider>
                <Row style={{marginBottom: '90px'}}>
                    <Col span={24} style={{textAlign: 'center'}}>
                        <FormPedidoDescricoes  
                            campo={campo}
                            label={label}
                            pedido={props.pedido}  
                            setFormVisible={setVisible}
                            abrirEdicaoObsHandle={() => setVisible(true)} 
                            formVisible={visible} /* dispatch={dispatch} */ />
                    </Col>
                </Row></>
}

export {PedidoDescricoes} 